export const environment = {

  production: false,
  
  API: 'https://ws-homo.bombeiros.to.gov.br/sgr',
  API_EXTERNO: 'https://ws-homo.bombeiros.to.gov.br/externo',
  API_INTRANET: 'https://ws-homo.bombeiros.to.gov.br/intranet',
  API_PREVENIR: 'https://ws-homo.bombeiros.to.gov.br/prevenir',
  API_SIOCB: 'https://ws-homo.bombeiros.to.gov.br/siocb',
  API_CRAF: 'https://ws-homo.bombeiros.to.gov.br/craf',
  HOST: 'https://sgr-homologacao.bombeiros.to.gov.br',
  URL_INTRANET: 'https://intranet-homologacao.bombeiros.to.gov.br',
  
  BASE_HREF: '/',
  METABASE_KEY: "d901e6be-38f8-4d9b-a2d4-1f3ccfb331f5",
  METABASE_KEY_COMPRAS: "455f951b-599b-47a6-a04f-c525c3247cf0",
  METABASE_KEY_INFORMATICA: "bae17eea-aa6a-4f0e-8926-d39192409d33"
};